module.exports = __webpack_public_path__ + "static/media/tutorial2.c7ec3a7c.svg";